import {EventMinicart} from '_types'
import {analyticsLogEvent} from '../api'

const eventName = 'removeFromMinicart'

interface Parameters {
    name: string
    masterId: string
    price: number
    categoryPath: string
    gender: string
    color: {
        code: string
        label: string
    }
    size: {
        code: string
        label: string
    }
    quantity?: number
    hasDiscount: boolean
    currencyCode: string
}

/**
 * Tracks a product quantity decrease or a removal from the minicart triggered by the user.
 *
 * @param {Parameters} params - Object containing the product details.
 * @param {string} params.name - The product's short description in english.
 * @param {string} params.masterId - The id of the product's master.
 * @param {number} params.price - The product's price.
 * @param {string} params.categoryPath - The product's analytics category path.
 * @param {string} params.gender - The product's gender in english.
 * @param {Object} params.color - The product's color details in english.
 * @param {Object} params.size - The product's size details.
 * @param {number | undefined} params.quantity - The product's quantity if it was removed, nothing otherwise (default=1).
 * @param {boolean} params.hasDiscount - Whether or not the product's price is discounted.
 * @param {string} params.currencyCode - The currency code being used.
 *
 */
export function analyticsEventMinicartRemoveFromCart({
    name,
    masterId,
    price,
    categoryPath,
    gender,
    color,
    size,
    quantity,
    hasDiscount,
    currencyCode,
}: Parameters): void {
    const eventDetails: EventMinicart = {
        ecommerce: {
            currencyCode: currencyCode,
            remove: {
                products: [
                    {
                        name: name,
                        id: masterId,
                        price: price.toFixed(2).toString(),
                        category: categoryPath,
                        variant: color.code,
                        color: color.label,
                        gender: gender,
                        dimension21: size.label,
                        dimension22: 'minicart',
                        dimension26: hasDiscount,
                        quantity: quantity?.toString() || '1',
                    },
                ],
            },
        },
    }

    analyticsLogEvent(eventName, eventDetails)
}
